import { EducatorPageChrome } from "@/pages/educators/page-chrome"
import { EducatorsReliefListingsBookingStudent } from "@/types/serializers"

import { useTranslation } from "react-i18next"
import { PageBody } from "@/components/ui/layout"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { educatorsTeacherReliefBookingStudent } from "@/routes"
import { Link, usePathParam, useProps } from "@/lib/page-rendering"

export type IndexProps = {
  students: Array<EducatorsReliefListingsBookingStudent>
  booking_title: string
}
const useIndexProps = () => useProps<IndexProps>()

export default function Page() {
  const { t } = useTranslation("educator_relief_listings", {
    keyPrefix: "bookings.students.index",
  })
  const { students, booking_title } = useIndexProps()
  const teacherId = usePathParam("teacherId")
  const bookingId = usePathParam("bookingId")

  return (
    <>
      <EducatorPageChrome identity={{ name: booking_title }} />
      <PageBody>
        <Card>
          <CardContent>
            {students.length > 0 ? (
              <ul className="grid w-full grid-cols-1 gap-4 pt-6 sm:grid-cols-2">
                {students.map((student) => (
                  <Card
                    key={student.student_id}
                    data-testid="student-card"
                    role="listitem"
                  >
                    <CardHeader>
                      <CardTitle>{student.student_name}</CardTitle>
                      <CardDescription>{student.school_name}</CardDescription>
                    </CardHeader>
                    <CardFooter>
                      <Button size="sm" className="w-full" asChild>
                        <Link
                          href={
                            educatorsTeacherReliefBookingStudent({
                              teacherId,
                              bookingId,
                              id: student.student_id,
                            }).url
                          }
                          className="w-full"
                        >
                          {t("view_student")}
                        </Link>
                      </Button>
                    </CardFooter>
                  </Card>
                ))}
              </ul>
            ) : null}
          </CardContent>
        </Card>
      </PageBody>
    </>
  )
}
